import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Input from '@material-ui/core/Input';
import Paper from '@material-ui/core/Paper';
import {
  EditingState,
  SortingState,
  IntegratedSorting,
  FilteringState,
  IntegratedFiltering,
  RowDetailState,
  DataTypeProvider,
} from '@devexpress/dx-react-grid'
import {
  Grid,
  VirtualTable,
  TableHeaderRow,
  TableFilterRow,
  TableEditRow,
  TableEditColumn,
  TableRowDetail,
} from '@devexpress/dx-react-grid-material-ui';

import MoneyFormat from './format/MoneyFormat.js';

import CustomerNameTypeProvider from './data_type_provider/CustomerNameTypeProvider.js';
import StringTypeProvider from './data_type_provider/StringTypeProvider.js';
import PhoneTypeProvider from './data_type_provider/PhoneTypeProvider.js';

import firebase from 'firebase/app';

import moment from 'moment';

require("moment-duration-format");
require("firebase/firestore");

const styles = theme => ({
});

const getRowId = row => row.id;

const columns = [
  { name: 'name', title: 'Name' },
  { name: 'phone', title: 'Phone' },
  { name: 'checkInTime', title: 'Check-In' },
  { name: 'checkOutTime', title: 'Check-Out' },
  { name: 'duration', title: 'Duration' },
  { name: 'pass', title: 'Pass' },
  { name: 'paymentAmount', title: '$' },
  { name: 'remark', title: 'Remark' },
];

const DateTypeProvider = () => (
  <DataTypeProvider
    for={['checkInTime', 'checkOutTime']}
    formatterComponent={({ value }) => value ? moment(value.toDate()).format('LT') : ''}
    editorComponent={({ column, row, value, onValueChange }) => <div />}
  />
);

const DurationTypeProvider = () => (
  <DataTypeProvider
    for={['duration']}
    formatterComponent={({ column, row, value }) =>
      row.checkOutTime ? moment.duration(moment(row.checkOutTime.toDate()).diff(row.checkInTime.toDate())).format("h:mm:ss", { trim: false }) : ''
    }
    editorComponent={({ column, row, value, onValueChange }) => <div />}
  />
);

const MoneyTypeProvider = () => (
  <DataTypeProvider
    for={['paymentAmount']}
    formatterComponent={({ value }) => <MoneyFormat displayType='text' value={value} /> }
    editorComponent={({ column, row, value, onValueChange }) =>
      row ?
      <Input
        fullWidth
        placeholder={!row ? "Filter..." : ""}
        value={value || ''}
        onChange={event => onValueChange(parseInt(event.target.value.replace(/\D/g,''), 10) || 0)}
        inputComponent={MoneyFormat}
      /> :
      <div/>
    }
  />
);

const detailRowTemplate = ({ row }) => <div>id: {row.id}</div>;

class DeskHistoryTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      date: new Date(),
      rows: [],
      users: this.props.users,
      passes: this.props.passes,

      width: window.innerWidth,
      height: window.innerHeight,

      unsubscribeDeskTransaction: null,
    };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  queryDeskTransaction = (props) => {
    let date = (props && props.date) || this.props.date;
    let branchId = (props && props.branchId) || this.props.branchId;

    if (!date || !branchId) {
      return;
    }

    return firebase.firestore()
      .collection("deskTransaction")
      .where('branch', '==', branchId)
      .where('checkInTime', '>=', moment(date).set({'hour': 0, 'minute': 0, 'second': 0, 'millisecond': 0}).toDate())
      .where('checkInTime', '<=', moment(date).set({'hour': 23, 'minute': 59, 'second': 59, 'millisecond': 999}).toDate())
      .onSnapshot(function(querySnapshot) {
        var rows = this.state.rows;
        querySnapshot.docChanges().forEach(change => {
          if (change.type === "added" || change.type === "modified") {
            let data = change.doc.data();
            data.id =  change.doc.id;

            // user info
            let user = this.props.users.find(user => {return user.id === data.userId});
            if (user) {
              data.name = user.name;
              data.phone = user.phone;
            }

            // pass info
            if (data.passUsed) {
              var found = this.props.passes.find(pass => {return pass.id === data.passUsed});
              data.pass = (found && found.name) || '';
            }

            let index = rows.findIndex(element => {
              return element.id === data.id;
            });
            if (index === -1) {
              rows.push(data);
            } else {
              rows[index] = data;
            }
          }
        });
        this.setState({
          rows: Array.from(rows),
        });
      }.bind(this));
  }

  startQuery(props) {
    this.setState({
      date: props.date,
      rows: Array.from([]),
      unsubscribeDeskTransaction: this.queryDeskTransaction(props),
    });
  }

  stopQuery() {
    this.state.unsubscribeDeskTransaction && this.state.unsubscribeDeskTransaction();
  }

  commitChanges = ({ added, changed, deleted }) => {
    if (changed) {
      for (var rowId in changed) {
        firebase.firestore()
          .collection("deskTransaction")
          .doc(rowId)
          .update(changed[rowId]);
      }
    }
  };

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
    this.startQuery(this.props.date, this.props.branchId);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
    this.stopQuery();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    let newState = {};

    if (nextProps.users) {
      newState.users = nextProps.users;
      // fetch user info
      let rows = this.state.rows;
      rows.forEach(row => {
        let user = nextProps.users.find(user => {return user.id === row.userId});
        if (user) {
          row.name = user.name;
          row.phone = user.phone;
        }
      });
      this.setState({rows: Array.from(rows)});
    }
    if (nextProps.passes) {
      newState.passes = nextProps.passes;
      // fetch pass info
      let rows = this.state.rows;
      rows.forEach(row => {
        if (row.passUsed) {
          var found = nextProps.passes.find(pass => {return pass.id === row.passUsed});
          row.pass = (found && found.name) || '';
        }
      });
      this.setState({rows: Array.from(rows)});
    }
    this.setState(newState);

    if (this.props.date !== nextProps.date || this.props.branchId !== nextProps.branchId) {
      this.stopQuery();
      this.startQuery(nextProps);
    }
  }

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }

  render() {
    // const { classes } = this.props;
    return(
      <Paper>
        <Grid
          rows={this.state.rows}
          getRowId={getRowId}
          columns={columns}>

          <PhoneTypeProvider for={['phone']} editable={false} />
          <DateTypeProvider />
          <DurationTypeProvider />
          <MoneyTypeProvider />
          <CustomerNameTypeProvider />
          <StringTypeProvider for={['pass']} editable={false} searchable={false} />
          <StringTypeProvider for={['remark']} />

          <EditingState onCommitChanges={this.commitChanges} />
          <RowDetailState />

          {/* Sorting */}
          <SortingState defaultSorting={[ {columnName: 'checkInTime', direction: 'desc'}, ]}/>
          <IntegratedSorting />

          {/* Filter */}
          <FilteringState />
          <IntegratedFiltering />

          <VirtualTable
            columnExtensions={[
              { columnName: 'name', width: (this.state.width - 261 - 48 - 150 - 48 - 100 - 80 - 80 - 70 - 100 - 70) / 2 },
              { columnName: 'phone', width: 100 },
              { columnName: 'checkInTime', width: 80 },
              { columnName: 'checkOutTime', width: 80 },
              { columnName: 'duration', width: 70 },
              { columnName: 'pass', width: 100 },
              { columnName: 'paymentAmount', width: 70 },
              { columnName: 'remark', width: (this.state.width - 261 - 48 - 150 - 48 - 100 - 80 - 80 - 70 - 100 - 70) / 2 },
            ]}
            height={this.state.height - 112} />
          <TableHeaderRow showSortingControls />
          <TableFilterRow />
          <TableRowDetail contentComponent={detailRowTemplate} />

          <TableEditRow />
          { this.props.currentUser.isAdmin ? <TableEditColumn showEditCommand /> : null }

        </Grid>
      </Paper>
    );
  }
}

DeskHistoryTable.propTypes = {
  classes: PropTypes.object.isRequired,
  currentUser: PropTypes.object.isRequired,
  branchId: PropTypes.string,
  passes: PropTypes.array.isRequired,
  date: PropTypes.instanceOf(Date),
  users: PropTypes.array.isRequired,
};

export default withStyles(styles)(DeskHistoryTable);
